'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import {Stepone} from './stepone';
import {Steptwo} from './steptwo';
import {Stepthree} from './stepthree';

class Tradein extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: this.props.product ? 2 : 1,
            idCategory: this.props.product ? this.props.product.id_category : false,
            product: this.props.product,
            idProduct: this.props.product ? this.props.product.id_product : false,

        };

        this.setCategory = this.setCategory.bind(this);
        this.setStep = this.setStep.bind(this);
        this.submit = this.submit.bind(this);
        this.setStateValue = this.setStateValue.bind(this);
    }

    setCategory(value){
        this.setState({idCategory: value});
    }

    setStateValue(key, value){
        let obj = {};
        obj[key] = value;
        this.setState(obj);
    }

    setStep(value){
        let st = {step: value};

        if(value == 1){
            st['product'] = false;
            st['idProduct'] = false;
        }
        this.setState(st);
        document.getElementById('tradein').scrollIntoView();
    }
    submit(){
        let form = document.getElementById('tradeinForm');
        let formData = new FormData(form);
        formData.append('_csrf', document.querySelector('meta[name="csrf-token"]').content);
        formData.append('phone', $('#tiPhone').val());

        const recipeUrl = baseUrl + 'tradein/submit/';

        const requestMetadata = {
            method: 'POST',
            body: formData,
        };

        fetch(recipeUrl, requestMetadata)
            .then(res => res.json())
            .then(res => {
                $('#modalThanks .modal-intro-text').html(res.data.message);
                $('#modalThanks .modal-title').html(res.data.title);
                $('#modalThanks').modal('show');
                window.dataLayer.push({
                    'event': 'form_submission',
                    'formName': 'Tradein'
                });
                $('#modalThanks').on('hidden.bs.modal', function () {
                    location.reload();
                })
            });
    }

    render() {

        let model = '';
        let selected = false;
        if (this.state.idCategory){
            if(this.state.idProduct){
                model = $('#tiIdProduct :selected').html();
            }else{
                model = document.getElementById('tiModel') && document.getElementById('tiModel').value ? document.getElementById('tiModel').value : (document.getElementById('tiConfiguration') ? document.getElementById('tiConfiguration').value : '');
            }

            selected = this.props.categories.filter((category) => category.id_category == this.state.idCategory);
        }

        return (
            <div className="trade-in-box__step-form">
                <div class="trade-in-box__step-form__list">
                    <div class={"trade-in-box__step-form__item" + (this.state.step == 1 || this.state.idCategory ? ' active' : '')}>
                        <div class="trade-in-box__step-form__num">01</div>
                        <If condition={!this.state.idCategory || this.state.step == 1}>
                            <div className="trade-in-box__step-form__txt">{lajax.t('Выберите категорию')}</div>
                        </If>
                        <If condition={this.state.idCategory && this.state.step != 1}>
                            <div className="trade-in-box__step-form__txt">
                                <div className="trade-in-box__step-form__txt__subhead">{lajax.t('Категория')}</div>
                                <div className="trade-in-box__step-form__txt__select">{selected[0].name} <a className="link-w-border" onClick={() => this.setStep(1)}>{lajax.t('Изменить')}</a></div>
                            </div>
                        </If>


                    </div>
                    <div class={"trade-in-box__step-form__item" + (this.state.step == 2 || model ? ' active' : '')}>
                        <div class="trade-in-box__step-form__num">02</div>
                        <If condition={!model || this.state.step == 2}>
                            <div className="trade-in-box__step-form__txt">{lajax.t('Данные о товаре')}</div>
                        </If>
                        <If condition={model && this.state.step != 2}>
                            <div className="trade-in-box__step-form__txt">
                                <div className="trade-in-box__step-form__txt__subhead">{lajax.t('Данные о товаре')}</div>
                                <div className="trade-in-box__step-form__txt__select"><span className={"trade-in-box__step-form__txt__over"}>{model}</span> <a className="link-w-border" onClick={() => this.setStep(2)}>{lajax.t('Изменить')}</a></div>
                            </div>
                        </If>
                    </div>
                    <div class={"trade-in-box__step-form__item" + (this.state.step == 3 ? ' active' : '')}>
                        <div class="trade-in-box__step-form__num">03</div>
                        <div class="trade-in-box__step-form__txt">{lajax.t('Контактные данные')}</div>
                    </div>
                </div>
                <form id={"tradeinForm"}>
                    <Stepone
                        active={this.state.step == 1}
                        categories={this.props.categories}
                        idCategory={this.state.idCategory}
                        setCategory={this.setCategory}
                        setStep={this.setStep}
                    />
                    <Steptwo
                        active={this.state.step == 2}
                        warranties={this.props.warranties}
                        classes={this.props.classes}
                        packages={this.props.packages}
                        idCategory={this.state.idCategory}
                        idProduct={this.state.idProduct}
                        setStep={this.setStep}
                        product={this.state.product}
                        setStateValue={this.setStateValue}
                    />
                    <Stepthree
                        active={this.state.step == 3}
                        submit={this.submit}
                        customer={this.props.customer}
                    />
                </form>


            </div>
        );
    }
}

const e = React.createElement;

$(function (){
    const domContainer = document.getElementById('tradein');

    if(domContainer){
        ReactDOM.render(e(Tradein, {
            categories: window.categories,
            classes: window.classes,
            warranties: window.warranties,
            packages: window.packages,
            product: window.product,
            customer: window.customer,
        }), domContainer);
    }

    const swiperTradeInSteps = new Swiper('.trade-in-box__step-list', {
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
        nextEl: '.trade-in-box__step-list-wrapper .swiper-button-next',
        prevEl: '.trade-in-box__step-list-wrapper .swiper-button-prev',
    },
        breakpoints: {
        620: {
        slidesPerView: 2,
        spaceBetween: 10
    },
        992: {
        slidesPerView: 3,
        spaceBetween: 20
    },
        1100: {
        slidesPerView: 4,
        spaceBetween: 20
    }
    }
    });

});
